import styled from 'styled-components';

export const TableHeaderItem = styled.div`
	min-width: ${(props) => props.minWidth};
`;
